import React, { memo } from 'react'
import { useTheme } from '@emotion/react'
import { Swiper, SwiperSlide } from 'swiper/react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PostCard from 'components/PostCard'
import { FormattedMessage } from 'react-intl'
import sx from './styles'

const RelatedPosts = ({ items, title }) => {
  const theme = useTheme()

  const options = {
    slidesPerView: 'auto',
    freeMode: true,
    spaceBetween: 10,
    grabCursor: true,
    breakpoints: {
      [theme.breakpoints.values.sm]: {
        slidesPerView: 3.5,
        freeMode: true,
        spaceBetween: 18,
      },
      [theme.breakpoints.values.md]: {
        slidesPerView: 5.5,
        freeMode: true,
        spaceBetween: 18,
      },
    },

  }

  return (
    <>
      <Box mt={4}>
        <Typography variant="h2">
          <FormattedMessage id={title} />
        </Typography>
      </Box>
      <Box sx={sx.swiper}>
        <Swiper {...options}>
          {items?.map((item, i) => (
            <SwiperSlide key={`posts-${i}`}>
              <PostCard
                item={item}
                key={`posts-${item?.id}`}
                sx={sx.imageCard}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </>
  )
}

export default memo(RelatedPosts)
